import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table, Modal, message, Form, Input, Select } from 'antd'
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'react-addons-update';
import UploadQiniu from '../../commponents/uploadQiniu/index'
import './swiper.less'
const FormItem = Form.Item;
const { Option } = Select;
let dragingIndex = -1;
class BodyRow extends React.Component {
	render() {
		const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
		const style = { ...restProps.style, cursor: 'move' };

		let { className } = restProps;
		if (isOver) {
			if (restProps.index > dragingIndex) {
				className += ' drop-over-downward';
			}
			if (restProps.index < dragingIndex) {
				className += ' drop-over-upward';
			}
		}

		return connectDragSource(
			connectDropTarget(<tr {...restProps} className={className} style={style} />),
		);
	}
}
const rowSource = {
	beginDrag(props) {
		dragingIndex = props.index;
		return {
			index: props.index,
		};
	},
};
const rowTarget = {
	drop(props, monitor) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;
		if (dragIndex === hoverIndex) {
			return;
		}
		props.moveRow(dragIndex, hoverIndex);
		monitor.getItem().index = hoverIndex;
	},
};
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
}))(
	DragSource('row', rowSource, connect => ({
		connectDragSource: connect.dragSource(),
	}))(BodyRow),
);
class Swiper extends Component {
	constructor(props) {
		super(props)
		this.state = {
			total: 0,
			swiperId: '',
			modelTitle: '新增轮播图',
			visible: false,
			releaseVisible: false,
			url: '',
			name: '',
			swiperName:'',
			linkAddr: '',
			positionType: '',
			subjectIcon: null,
			pcIcon: null,
			changeSwitch: false,
			qiuniuUrl: '',
			circleType: 1,
			searchData: {
				name: '',
				status: '',
				pageNum: 1,
				pageSize: 10,
				onChange:()=>{
					this.getSwiperList()
				}
			},
			columns: [
				{
					title: '轮播图',
					dataIndex: 'pic',
					key: 'pic',
					align: 'center',
					render: (record)=> 
						<img src={record} style={{width: '141px',height: '80px'}} alt=""/>
				},
				{
					title: '轮播图名称',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: '链接类型',
					dataIndex: 'type',
					key: 'type',
					align: 'center',
					render: (record,text)=> {
						if(text.type === 0) {
							return (
								<span>H5链接</span>
							)
						}
						if(text.type === 1) {
							return (
								<span>小程序内部链接</span>
							)
						}
						if(text.type === 2) {
							return (
								<span>第三方小程序链接</span>
							)
						}
					}
				},
				{
					title: '跳转链接',
					dataIndex: 'linkAddr',
					key: 'linkAddr',
					align: 'center'
				},
				{
					title: '广告位置',
					dataIndex: 'positionType',
					key: 'positionType',
					align: 'center',
					render: (record) => <span>{record === 0?'首页推荐':'就业课'}</span>
				},
				{
					title: '创建人',
					dataIndex: 'userName',
					key: 'userName',
					align: 'center'
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								swiperId: record.id,
								visible: true,
								modelTitle: '编辑轮播',
								swiperName: record.name,
								linkAddr: record.linkAddr,
								positionType: record.positionType,
								circleType: record.type,
								appid: record.appid,
								subjectIcon: {
									uid: record.uploadUid,
									type: record.uploadType,
									url: record.pic,
									name: record.name
								},
								pcIcon: {
									uid: record.pcUploadUid||'',
									// type: '',
									url: record.pcPic,
									name: record.name
								}

							})
						}}>编辑</span>
						<span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							Modal.confirm({
								title: '删除操作',
								okText: "确认",
								cancelText: "取消",
								content: (
									<div>
										<p style={{ whiteSpace: 'nowrap' }}>删除后不可恢复，请谨慎操作！确定要删除吗？</p>
									</div>
								),
								onOk: () => {
									this.delSwiper(record.id)
								},
							});
						}}>删除</span>
					</div>
				},
			],
			subjecListData: [],
			notChanged: []

		}
	}
	async getSwiperList() {
		axios.post('bannerController/getList', {
			...this.state.searchData
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					subjecListData: res.data.data,
					notChanged: res.data.data,
				})
			}
		})
	}
	delSwiper(id) {
		axios.get(`bannerController/del/${id}`).then(res => {
			if(res.data.code === '200') {
				message.success('删除成功')
				this.getSwiperList()
			}else {
				message.success(res.data.msg)
			}
		})
	}
	handleOk = (e) => {
		let _this = this
		this.props.form.validateFields((err, values) => {
			if(!err) {
				if(this.state.modelTitle === '新增轮播'){
					axios.post('bannerController/add', {
						pic: this.state.qiuniuUrl+'/'+ values.swiperUpload.response.key,
						pcPic: this.state.qiuniuUrl+'/'+values.pcSwiperUpload.response.key,
						pcUploadUid: values.pcSwiperUpload.uid,
						name: values.name,
						linkAddr: values.linkAddr,
						positionType: values.positionType,
						type: values.circleType,
						uploadType: values.swiperUpload.type,
						uploadUid: values.swiperUpload.uid,
						appid: values.appid
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.getSwiperList()
						} else {
							message.error(res.data.msg)
						}
					})
				}else {
					let pic = values.swiperUpload.url&&values.swiperUpload.url ? values.swiperUpload.url :this.state.qiuniuUrl +'/'+ values.swiperUpload.response.key
					let pcPic = values.pcSwiperUpload.url&&values.pcSwiperUpload.url ? values.pcSwiperUpload.url :this.state.qiuniuUrl +'/'+ values.pcSwiperUpload.response.key
					axios.post('bannerController/update', {
						id: _this.state.swiperId,
						pic: pic,
						name: values.name,
						type: values.circleType,
						pcPic: pcPic,
						pcUploadUid: values.pcSwiperUpload.uid,
						linkAddr: values.linkAddr,
						positionType: values.positionType,
						uploadType: values.swiperUpload.type,
						uploadUid: values.swiperUpload.uid,
						appid: values.appid
					}).then(res => {
						if (res.data.code === '200') {
							message.success('修改成功')
							_this.props.form.resetFields();
							_this.setState({ visible: false })
							_this.getSwiperList()
						} else {
							message.error(res.data.msg)
						}
					})
				}
				
			}
			
		});
	}
	componentDidMount() {
		this.getSwiperList()
	}
	componentWillUnmount() {
		this.setState = ()=>false;
	}
	showModal() {
		this.setState({ visible: true, modelTitle: '新增轮播',circleType: 1, subjectIcon: '',appid: '', pcIcon: '' })
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	components = {
		body: {
			row: DragableBodyRow,
		},
	};
	moveRow = (dragIndex, hoverIndex) => {
		const { subjecListData } = this.state;
		const dragRow = subjecListData[dragIndex];
		this.setState(
			update(this.state, {
				subjecListData: {
					$splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
				},
			}),
		);
		let oldSort = []
		for (let i = 0; i < this.state.notChanged.length; i++) {
			oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.subjecListData[i].id })
		}
		axios.post('/bannerController/updateSort',oldSort).then(res => {
			if(res.data.code === '200' ){
				this.getSwiperList()
				message.success('更新排序成功')
			}else {
				message.error(res.data.msg)
			}
			oldSort = []
		})
		

	};
	render() {
		const { visible, columns, subjecListData, modelTitle, swiperName, subjectIcon, pcIcon, linkAddr, positionType, searchData, circleType, appid } = this.state;
		const { getFieldDecorator } = this.props.form;
		return (
			<div className="swiper">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>轮播图管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
						<Input allowClear value={searchData.name} style={{ width: '260px', height: '40px', marginRight: '20px' }} 
						placeholder="请输入轮播名称"
						onChange={(e)=>{
							// setInputValue(e.target.value)
							e.persist()
							this.setState({
								searchData: {
									name: e.target.value
								}
							})
						}}
						></Input>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.getSwiperList()
						}}>搜索</Button>
						<span style={{marginLeft: '20px'}} className='my-button-txt' onClick={() => {
							this.setState({searchData: {
								name: ''
							}},()=>{
								this.getSwiperList()
							})
						}}>重置</span>
					</div>
					<Button className='my-button-primary' type='primary' onClick={() => { this.showModal() }}>新增轮播</Button>
				</div>
				<DndProvider backend={HTML5Backend}>
					<Table
						dataSource={subjecListData}
						columns={columns}
						components={this.components}
						rowKey={record => record.id+''}
						rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
						})}
					/>
				</DndProvider>
				<Modal
					getContainer={false}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }} onSubmit={this.handleOk}>
						<FormItem label={"轮播名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入轮播名称!' },{max: 50, message: '最多输入50个字符'}],
								initialValue:modelTitle==='编辑轮播'? swiperName: ''
							})(
								<Input allowClear placeholder='请输入轮播名称' />
							)}
						</FormItem>
						<Form.Item label="轮播图">
							{getFieldDecorator('swiperUpload', {
								initialValue: modelTitle==='编辑轮播'? subjectIcon: '',
								rules: [{ type: 'object', required: true, message: '请上传轮播图!' }],
							})(
								// <div>
									<UploadQiniu  getQiniuUrl={this.getQiniuUrl}/>
									// <p style={{color: '#999999',fontSize: '12px',lineHeight: 1.5,marginTop: '5px'}}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*266px</p>
								// </div>
								
							)}
						</Form.Item>
						<Form.Item label="pc轮播图">
							{getFieldDecorator('pcSwiperUpload', {
								initialValue: modelTitle==='编辑轮播'? pcIcon: '',
								rules: [{ type: 'object', required: true, message: '请上传pc轮播图!' }],
							})(
								// <div>
									<UploadQiniu  getQiniuUrl={this.getQiniuUrl}/>
									// <p style={{color: '#999999',fontSize: '12px',lineHeight: 1.5,marginTop: '5px'}}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*266px</p>
								// </div>
								
							)}
						</Form.Item>
						<Form.Item label="链接类型">
							{getFieldDecorator('circleType', {
								rules: [{ required: true, message: '请选择链接类型' }],
								initialValue: modelTitle==='编辑轮播'? circleType: circleType
							})(
								<Select
									placeholder="请选择链接类型"
									onChange={(val) => {this.setState({circleType: val})}}
								>
									<Option value={0}>H5链接</Option>
									<Option value={1}>小程序内部链接</Option>
									<Option value={2}>第三方小程序链接</Option>
								</Select>
							)}
						</Form.Item>
						<FormItem label={"跳转链接"}>
							{getFieldDecorator('linkAddr', {
								rules: [{required: true, message: '请输入跳转链接'}],
								initialValue:modelTitle==='编辑轮播'? linkAddr: ''
							})(
								<Input allowClear maxLength={200} placeholder='请输入跳转链接' />
							)}
						</FormItem>
						<FormItem label={"轮播位置"}>
							{getFieldDecorator('positionType', {
								rules: [{required: true, message: '请选择轮播位置'}],
								initialValue:modelTitle==='编辑轮播'? positionType: ''
							})(
								<Select
									placeholder="请选择轮播位置"
									onChange={(val) => {this.setState({positionType: val})}}
								>
									<Option value={0}>首页推荐</Option>
									<Option value={1}>就业课</Option>
									<Option value={2}>赋能课</Option>
								</Select>
							)}
						</FormItem>
						{circleType === 2?<FormItem label={"AppID"}>
							{getFieldDecorator('appid',{initialValue: modelTitle==='编辑轮播'? appid: '',
							rules: [{required: true, message: '请输入AppID'}]
						})(
								<Input style={{width: '100%'}} maxLength={200} placeholder='请输入AppID' />
							)}
						</FormItem>:''}
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create()(Swiper)